import React, { useEffect, useState } from "react"
import { Button, convertCentsToDollars, convertDollarToCents } from "@thdinc/hpf-shared";
import Dropdown from "@/components/Dropdown/Dropdown";
import Tabs from "@/components/tabs/Tabs"
import AlcohalCard from "@/components/alcohalCard/AlcohalCard";
import MixersCard from "@/components/mixersCard/MixersCard";
import { API_ROUTES } from "@/services/environment";
import { useAppSelector } from "@/hooks/hook";
import { DELETE, GET, PATCH, POST } from "@/services/api";
import FormModal from "@/components/modals/FormModal";
import Dropzone from "@/components/dropzone/DropZone";
import ImageUploadFunDropZone from "@/utils/ImageUploadDropZoneFun";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { AlcoholBrand, MixersAndSyrups, Product, ProductModal, StoreList } from "./interface";
import SelectSearchInput from "@/components/selectInput/SelectSearchInput";
import { COCKTAILS_TYPES_DATA, SPIRITS_BRAND_DATA, ADDITIONAL_BEVERAGES_DATA } from "@/constants/CompanyData";
import Alert from "@/components/alert/Alert";
import ChangesAlert from "@/components/alert/ChangesAlert";
import ToggleInput from "@/components/toggle/Toggle";

const tabsList = ["Spirits Brands", "Additional Beverages", "Mixers/Syrups"];

const AlcohalAndMixers = () => {
    const { getStoresApi, products: storeProducts, productMixers } = API_ROUTES;
    const { refreshToken } = useAppSelector((store) => store.user);
    const [activeTab, setActiveTab] = useState(tabsList[0]);
    const [productModal, setProductModal] = useState<ProductModal>({ isOpen: false, storeType: [] });
    const [isMixersOpen, setMixersIsOpen] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isProductLoading, setProductLoading] = useState<boolean>(false);
    const [mixersLoading, setMixersLoading] = useState<boolean>(false);
    const [changeModal, setChangeModal] = useState<boolean>(false);
    const [unSavedPreference, setUnSavedPreference] = useState<boolean>(false);
    const [mixersProductLoading, setMixersProductLoading] = useState<boolean>(false);
    const [selectedValue, setSelectedValue] = useState<string | StoreList>('');
    const [selectedStore, setSelectedStore] = useState<StoreList>();
    const [products, setProducts] = useState<Product[]>([]);
    const [mixersProducts, setMixersProducts] = useState<Product[]>([]);
    const [productStatus, setProductStatus] = useState<string>('active');
    const [editProduct, setEditProduct] = useState<{ isEdit: boolean; productId: string }>({ isEdit: false, productId: '' });
    const [deleteProduct, setDeleteProduct] = useState<{ id: string; type: string }>({ id: '', type: '' });
    const [tabChange, setTabChange] = useState<{ modal: boolean; tab: string }>({ modal: false, tab: '' });
    const [storeList, setStoresList] = useState<StoreList[]>([]);
    const [cocktailImg, setCocktailImg] = useState<string | null>(null);
    const [cocktailImgFile, setCocktailImgFile] = useState<File | null>(null);
    const [imageError, setImageError] = useState<string>("");
    //react-hook-form
    const {
        formState: { errors, isValid },
        register,
        handleSubmit,
        reset,
        trigger,
        setValue,
        watch,
        control,
        getValues
    } = useForm<AlcoholBrand>({
        defaultValues: {
            quantity: 1,
        }
    });
    const {
        formState: { errors: mixersError },
        register: mixersRegister,
        handleSubmit: mixersHandleSubmit,
        reset: mixersReset,
    } = useForm<MixersAndSyrups>();

    useEffect(() => {
        (async () => {
            try {
                setProductLoading(true);
                const res = await GET(`${getStoresApi}`, refreshToken);
                if (res?.data?.length > 0) {
                    setStoresList(res.data);
                    setSelectedValue(res.data[0])
                    handleProductStore(res.data[0])
                    setSelectedStore(res.data[0])
                }
            } catch (error) {
                Alert({ type: 'error', message: 'Unable to fetch product' });
            } finally {
                setProductLoading(false)
            }
        })();
    }, []);
    useEffect(() => {
        (async () => {
            try {
                setMixersProductLoading(true);
                const res = await GET(`${productMixers}`, refreshToken);
                if (res?.data?.length > 0) {
                    setMixersProducts(res.data)
                } else {
                    setMixersProducts([])
                }
            } catch (error) {
                Alert({ type: 'error', message: 'Unable to fetch product' });
            } finally {
                setMixersProductLoading(false)
            }
        })();
    }, []);
    useEffect(() => {
        const selectedStore = storeList.find((store => store.name == selectedValue))
        selectedStore && setSelectedStore(selectedStore)
        handleProductStore(selectedStore)
    }, [selectedValue])
    useEffect(() => {
        if (productModal.storeType.length === 1) {
            setValue('type', productModal.storeType[0]?.value)
        }
    }, [productModal.isOpen])
    const handleProductStore = async (store: StoreList | undefined) => {
        if (store) {
            try {
                const res = await GET(`${storeProducts}/${store?.id}`, refreshToken);
                if (res?.data?.length > 0) {
                    setProducts(res.data)
                } else {
                    setProducts([])
                }
            } catch (error) {
                console.log('get store product error:')
            }
        }
    }
    const handleTabChange = (tab: string) => {
        if (unSavedPreference && activeTab == 'Spirits Brands') {
            setTabChange({
                modal: true,
                tab: tab
            })
        } else {
            setActiveTab(tab)
        }
    };
    const handleOptionChange = (value: string) => {
        setSelectedValue(value);
    };
    const handleRemoveProduct = async (id: string, type?: string) => {
        setDeleteProduct({
            id: id,
            type: type ?? ''
        })
        setChangeModal(true);
    };
    const handleModalCancel = () => {
        setChangeModal(false);
        setDeleteProduct({
            id: '',
            type: ''
        })
    }
    const handleTabModalOkay = async () => {
        setTabChange({
            modal: false,
            tab: ''
        })
    }
    const handleTabModalCancel = () => {
        setActiveTab(tabChange.tab)
        setTabChange({
            modal: false,
            tab: ''
        })
    }
    const handleModalOkay = async () => {
        setChangeModal(false)
        const { id, type } = deleteProduct;
        if (type === 'mixers') {
            setMixersProducts(mixersProducts.filter((p) => p.id !== id));
        } else {
            setProducts(products.filter((p) => p.id !== id));
        }
        try {
            await DELETE(`${storeProducts}/${id}?storeId=${selectedStore?.id}`, refreshToken);
            Alert({ message: `Product deleted successfully` });
        } catch (error: any) {
            Alert({ type: "error", message: "Failed to delete product. Please try again." });
        } finally {
            setDeleteProduct({
                id: '',
                type: ''
            })
        }
    }
    const handleEditClick = (product: Product) => {
        setEditProduct({
            isEdit: true,
            productId: product.id
        });
        setProductModal({
            isOpen: true,
            storeType: [{ name: product.title, value: product.type }]
        });
        //in edit we are using url instead of filePath
        setCocktailImgFile(null);
        setCocktailImg(product.image);
        setValue('type', product.type);
        setValue('brand_name', product.name);
        setValue('total_price', Number(convertCentsToDollars(product?.price?.toString())));
        setValue('size', product.size);
        setValue('quantity', product.quantity)
        setProductStatus(product.status)

    };
    const onImageUpload = (file: any) => {
        try {
            const f = ImageUploadFunDropZone(file);
            if (f) {
                setCocktailImgFile(f);
                setCocktailImg(URL.createObjectURL(f));
                setImageError("");
            }
        } catch (err: any) {
            setImageError(err.message);
        }
    };
    const onProductModalClose = () => {
        setProductModal({ isOpen: false, storeType: [] });
        reset();
        setImageError('');
        setCocktailImg(null);
        setCocktailImgFile(null);
        setEditProduct({
            isEdit: false,
            productId: ''
        });
        setProductStatus('active')
    }
    const onSubmit: SubmitHandler<AlcoholBrand> = async (data: AlcoholBrand) => {
        if (cocktailImgFile || cocktailImg) {
            const selectedStore = storeList.find((store) => store.name === (typeof selectedValue === "object" ? selectedValue.name : selectedValue));
            const formData = new FormData();
            if (cocktailImgFile) {
                formData.append("image", cocktailImgFile);
            }
            if (cocktailImgFile === null && cocktailImg) {
                formData.append("image", cocktailImg);
            }
            formData.append("type", String(data.type));
            formData.append("name", String(data.brand_name));
            formData.append("price", convertDollarToCents(String(data.total_price)));
            formData.append("size", String(data.size));
            formData.append("quantity", String(data.quantity));
            formData.append("status", String(productStatus));
            editProduct.isEdit && formData.append('store_id', selectedStore?.id ?? '');
            try {
                setIsLoading(true);
                //edit product
                if (editProduct.isEdit && editProduct.productId) {
                    const res = await PATCH(`${storeProducts}/${editProduct.productId}`, formData, refreshToken);
                    if (!res?.data?.success) {
                        Alert({ type: 'error', message: res?.data?.message });
                        return;
                    }
                    setProducts((prevProducts) => {
                        const updatedProduct = res?.data?.data;
                        const existingIndex = prevProducts.findIndex(p => p.id === updatedProduct.id);
                        if (existingIndex !== -1) {
                            const updatedProducts = [...prevProducts];
                            updatedProducts[existingIndex] = updatedProduct;
                            return updatedProducts;
                        } else {
                            return [...prevProducts];
                        }
                    });
                    Alert({ message: res?.data?.message });
                }
                //add new product
                else {
                    const res = await POST(`${storeProducts}/${selectedStore?.id}`, formData, refreshToken);
                    if (!res?.data?.success) {
                        Alert({ type: 'error', message: res?.data?.message });
                        return;
                    }
                    setProducts([...products, res?.data?.data])
                    Alert({ message: res?.data?.message });
                }
                onProductModalClose();
            } catch (error) {
                if (editProduct.isEdit) {
                    Alert({ type: 'error', message: 'Unable to update product' });
                } else {
                    Alert({ type: 'error', message: 'Unable to add product' });
                }
            } finally {
                setIsLoading(false);
            }
        }
    };
    const onMixersSubmit: SubmitHandler<MixersAndSyrups> = async (data: MixersAndSyrups) => {
        const selectedStore = storeList.find((store) => store.name === (typeof selectedValue === "object" ? selectedValue.name : selectedValue));
        try {
            setMixersLoading(true);
            const formData = new FormData();
            formData.append("type", 'mixers');
            formData.append("name", data?.name);
            const res = await POST(`${storeProducts}/${selectedStore?.id}`, formData, refreshToken);
            if (!res?.data?.success) {
                Alert({ type: 'error', message: res?.data?.message });
                return;
            }
            setMixersProducts([...mixersProducts, res?.data?.data])
            setProducts([...products, res?.data?.data])
            mixersReset();
            Alert({ message: res?.data?.message });
            setMixersIsOpen(false);
        } catch (error) {
            Alert({ type: 'error', message: 'Unable to add mixers/syrups' });
        } finally {
            setMixersLoading(false);
        }
    };
    return (
        <div>
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center pt-4 gap-3">
                <Tabs
                    tabs={tabsList}
                    activeTab={activeTab}
                    onTabChange={handleTabChange}
                />
                <Button onClick={() => {
                    activeTab == 'Mixers/Syrups' ?
                        setMixersIsOpen(true) :
                        setProductModal({ isOpen: true, storeType: [] })
                }}
                    type="button" classes={"bg-black text-white"}>
                    {" + Add New"}
                </Button>
            </div>
            {activeTab !== 'Mixers/Syrups' && <div className="mt-4">
                <Dropdown
                    options={storeList ?? []}
                    selectedValue={selectedValue}
                    onOptionChange={handleOptionChange}
                />
            </div>}
            {activeTab == 'Spirits Brands' &&
                <div className="mt-4 flex flex-col gap-4">
                    <AlcohalCard
                        products={products.filter(product => product.type == 'tequila')}
                        onhandleRemove={handleRemoveProduct}
                        showPreferredSection={true}
                        setProductModal={setProductModal}
                        header={{ title: 'Tequila', type: ['tequila'] }}
                        setEditProduct={handleEditClick}
                        isloading={isProductLoading}
                        selectedStore={selectedStore}
                        activeTab={activeTab}
                        setUnSavedPreference={setUnSavedPreference}
                    />
                    <AlcohalCard
                        products={products.filter(product => product.type == 'vodka')}
                        onhandleRemove={handleRemoveProduct}
                        showPreferredSection={true}
                        setProductModal={setProductModal}
                        header={{ title: 'Vodka', type: ['vodka'] }}
                        setEditProduct={handleEditClick}
                        isloading={isProductLoading}
                        selectedStore={selectedStore}
                        activeTab={activeTab}
                        setUnSavedPreference={setUnSavedPreference}
                    />
                    <AlcohalCard
                        products={products.filter(product => product.type == 'whisky')}
                        onhandleRemove={handleRemoveProduct}
                        showPreferredSection={true}
                        setProductModal={setProductModal}
                        header={{ title: 'Whisky', type: ['whisky'] }}
                        setEditProduct={handleEditClick}
                        isloading={isProductLoading}
                        selectedStore={selectedStore}
                        activeTab={activeTab}
                        setUnSavedPreference={setUnSavedPreference}
                    />
                    <AlcohalCard
                        products={products.filter(product => product.type == 'rum')}
                        onhandleRemove={handleRemoveProduct}
                        showPreferredSection={true}
                        setProductModal={setProductModal}
                        header={{ title: 'Rum', type: ['rum'] }}
                        setEditProduct={handleEditClick}
                        isloading={isProductLoading}
                        selectedStore={selectedStore}
                        activeTab={activeTab}
                        setUnSavedPreference={setUnSavedPreference}
                    />
                    <AlcohalCard
                        products={products.filter(product => product.type == 'gin')}
                        onhandleRemove={handleRemoveProduct}
                        showPreferredSection={true}
                        setProductModal={setProductModal}
                        header={{ title: 'Gin', type: ['gin'] }}
                        setEditProduct={handleEditClick}
                        isloading={isProductLoading}
                        selectedStore={selectedStore}
                        activeTab={activeTab}
                        setUnSavedPreference={setUnSavedPreference}
                    />
                    <AlcohalCard
                        products={products.filter(product => product.type == 'mezcal')}
                        onhandleRemove={handleRemoveProduct}
                        showPreferredSection={true}
                        setProductModal={setProductModal}
                        header={{ title: 'Mezcal', type: ['mezcal'] }}
                        setEditProduct={handleEditClick}
                        isloading={isProductLoading}
                        selectedStore={selectedStore}
                        activeTab={activeTab}
                        setUnSavedPreference={setUnSavedPreference}
                    />
                    <AlcohalCard
                        products={products.filter(product => product.type == 'cognac')}
                        onhandleRemove={handleRemoveProduct}
                        showPreferredSection={true}
                        setProductModal={setProductModal}
                        header={{ title: 'Cognac', type: ['cognac'] }}
                        setEditProduct={handleEditClick}
                        isloading={isProductLoading}
                        selectedStore={selectedStore}
                        activeTab={activeTab}
                        setUnSavedPreference={setUnSavedPreference}
                    />
                    <AlcohalCard
                        products={products.filter(product => product.type == 'liqueur')}
                        onhandleRemove={handleRemoveProduct}
                        showPreferredSection={true}
                        setProductModal={setProductModal}
                        header={{ title: 'Liqueur', type: ['liqueur'] }}
                        setEditProduct={handleEditClick}
                        isloading={isProductLoading}
                        selectedStore={selectedStore}
                        activeTab={activeTab}
                        setUnSavedPreference={setUnSavedPreference}
                    />
                    <AlcohalCard
                        products={products.filter(product => product.type == 'mocktail')}
                        onhandleRemove={handleRemoveProduct}
                        showPreferredSection={true}
                        setProductModal={setProductModal}
                        header={{ title: 'Mocktail', type: ['mocktail'] }}
                        setEditProduct={handleEditClick}
                        isloading={isProductLoading}
                        selectedStore={selectedStore}
                        activeTab={activeTab}
                        setUnSavedPreference={setUnSavedPreference}
                    />
                    <AlcohalCard
                        products={products.filter(product => product.type == 'sparkling')}
                        onhandleRemove={handleRemoveProduct}
                        showPreferredSection={true}
                        setProductModal={setProductModal}
                        header={{ title: 'Sparkling', type: ['sparkling'] }}
                        setEditProduct={handleEditClick}
                        isloading={isProductLoading}
                        selectedStore={selectedStore}
                        activeTab={activeTab}
                        setUnSavedPreference={setUnSavedPreference}
                    />
                    <AlcohalCard
                        products={products.filter(product => product.type == 'rum_dark')}
                        onhandleRemove={handleRemoveProduct}
                        showPreferredSection={true}
                        setProductModal={setProductModal}
                        header={{ title: 'Rum Dark', type: ['rum_dark'] }}
                        setEditProduct={handleEditClick}
                        isloading={isProductLoading}
                        selectedStore={selectedStore}
                        activeTab={activeTab}
                        setUnSavedPreference={setUnSavedPreference}
                    />
                    <AlcohalCard
                        products={products.filter(product => product.type == 'vermouth')}
                        onhandleRemove={handleRemoveProduct}
                        showPreferredSection={true}
                        setProductModal={setProductModal}
                        header={{ title: 'Vermouth', type: ['vermouth'] }}
                        setEditProduct={handleEditClick}
                        isloading={isProductLoading}
                        selectedStore={selectedStore}
                        activeTab={activeTab}
                        setUnSavedPreference={setUnSavedPreference}
                    />
                </div>}
            {activeTab == 'Additional Beverages' && <div className="mt-4 flex flex-col gap-4">
                <AlcohalCard
                    products={products.filter(product => product.type == 'beer' || product.type == 'seltzer' || product.type == 'beer_cocktail')}
                    onhandleRemove={handleRemoveProduct}
                    showPreferredSection={false}
                    setProductModal={setProductModal}
                    header={{ title: 'Beer/Seltzer', type: ['beer', 'seltzer'] }}
                    setEditProduct={handleEditClick}
                    isloading={isProductLoading}
                />
                <AlcohalCard
                    products={products.filter(product => product.type == 'red_wine')}
                    onhandleRemove={handleRemoveProduct}
                    showPreferredSection={false}
                    setProductModal={setProductModal}
                    header={{ title: 'Red Wine', type: ['red_wine'] }}
                    setEditProduct={handleEditClick}
                    isloading={isProductLoading}
                />
                <AlcohalCard
                    products={products.filter(product => product.type == 'white_wine')}
                    onhandleRemove={handleRemoveProduct}
                    showPreferredSection={false}
                    setProductModal={setProductModal}
                    header={{ title: 'White Wine', type: ['white_wine'] }}
                    setEditProduct={handleEditClick}
                    isloading={isProductLoading}
                />
                <AlcohalCard
                    products={products.filter(product => product.type == 'sparkling_wine')}
                    onhandleRemove={handleRemoveProduct}
                    showPreferredSection={false}
                    setProductModal={setProductModal}
                    header={{ title: 'Sparkling Wine', type: ['sparkling_wine'] }}
                    setEditProduct={handleEditClick}
                    isloading={isProductLoading}
                />
                <AlcohalCard
                    products={products.filter(product => product.type == 'water')}
                    onhandleRemove={handleRemoveProduct}
                    showPreferredSection={false}
                    setProductModal={setProductModal}
                    header={{ title: 'Water', type: ['water'] }}
                    setEditProduct={handleEditClick}
                    isloading={isProductLoading}
                />
            </div>}
            {activeTab == 'Mixers/Syrups' &&
                <div className="mt-4">
                    <MixersCard
                        setMixersIsOpen={setMixersIsOpen}
                        onRemove={handleRemoveProduct}
                        isLoading={mixersProductLoading}
                        mixers={mixersProducts} />
                </div>}
            <FormModal
                overflow="overflow-hidden "
                modalTitle={"Alcohol Brands"}
                isOpen={productModal.isOpen}
                onClose={() => onProductModalClose()}
                width="lg:w-3/6 md:w-5/6 w-full">
                <div className="flex flex-col mt-4 items-center">
                    <Dropzone
                        image={cocktailImg}
                        removeImage={() => {
                            setCocktailImg(null);
                            setCocktailImgFile(null);
                        }}
                        onDrop={onImageUpload}
                    ></Dropzone>
                    {imageError && (
                        <p className="text-red-500 text-xs ">{imageError}</p>
                    )}
                    <div className=" font-semibold my-2">Brand Image</div>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="flex flex-col gap-4 sm:flex-row sm:gap-8 mt-3">
                        <div className=" w-full">
                            <p className="font-semibold  text-xs mb-2 ml-4 ">Type</p>
                            <Controller
                                name="type"
                                control={control}
                                rules={{ required: "Type is required" }}
                                render={({ field, fieldState: { error } }) => (
                                    <>
                                        <SelectSearchInput
                                            placeholder="Select Type"
                                            options={productModal.storeType.length === 0 ?
                                                activeTab == 'Spirits Brands' ?
                                                    SPIRITS_BRAND_DATA : activeTab == 'Additional Beverages' ?
                                                        ADDITIONAL_BEVERAGES_DATA :
                                                        COCKTAILS_TYPES_DATA.filter(product => product.name !== 'Other')
                                                : productModal.storeType}
                                            disabled={productModal.storeType.length === 1 && true}
                                            value={field.value}
                                            onChange={async (selectedValue: string) => {
                                                field.onChange(selectedValue);
                                                await trigger('type');
                                            }}
                                        />
                                        <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
                                            {error?.message}
                                        </p>
                                    </>
                                )}
                            />
                        </div>
                        <div className=" w-full">
                            <p className="font-semibold  text-xs mb-2 ml-4 ">Brand Name</p>
                            <input
                                type="text"
                                maxLength={50}
                                className="w-full px-4 py-3 bg-p-gray rounded-full focus:outline-none focus:ring-1 focus:ring-primary-red text-gray-600"
                                placeholder={"Brand Name"}
                                {...register("brand_name", {
                                    required: "Brand Name is required",
                                })}
                            />
                            <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
                                {errors?.brand_name?.message}
                            </p>
                        </div>
                    </div>
                    <div className="flex flex-col gap-4 sm:flex-row sm:gap-8 mt-3">
                        <div className=" w-full">
                            <p className="font-semibold  text-xs mb-2 ml-4 ">Total Price</p>
                            <input
                                type="number"
                                step="0.01"
                                onInput={(e: any) => {
                                    const value = e.target.value;
                                    if (value.length > 15) {
                                        e.target.value = value.slice(0, 15);
                                    }
                                    const decimalIndex = value.indexOf('.');
                                    if (decimalIndex >= 0 && value.length - decimalIndex > 3) {
                                        e.target.value = value.slice(0, decimalIndex + 3);
                                    }
                                }}
                                className="w-full px-4 py-3 bg-p-gray rounded-full focus:outline-none focus:ring-1 focus:ring-primary-red text-gray-600"
                                placeholder={"Total Price"}
                                {...register("total_price", {
                                    required: "Total price is required",
                                    min: {
                                        value: 1,
                                        message: "Price must be greater than 0 ",
                                    },
                                })}
                            />
                            <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
                                {errors?.total_price?.message}
                            </p>
                        </div>
                        <div className="w-full">
                            <p className="font-semibold  text-xs mb-2 ml-4 ">Size
                                {activeTab == 'Spirits Brands' && ' (mL)'}
                                {activeTab == 'Additional Beverages' && (getValues('type') == 'beer' ? ' (oz)' : ' (mL)')}
                            </p>
                            <input
                                type="number"
                                step="0.01"
                                onInput={(e: any) => {
                                    const value = e.target.value;
                                    if (value.length > 15) {
                                        e.target.value = value.slice(0, 15);
                                    }
                                    const decimalIndex = value.indexOf('.');
                                    if (decimalIndex >= 0 && value.length - decimalIndex > 3) {
                                        e.target.value = value.slice(0, decimalIndex + 3);
                                    }
                                }}
                                className="w-full px-4 py-3 bg-p-gray rounded-full focus:outline-none focus:ring-1 focus:ring-primary-red text-gray-600"
                                placeholder={"Size"}
                                {...register("size", {
                                    required: "Size is required",
                                    min: {
                                        value: 1,
                                        message: "Size must be greater than 0 ",
                                    },
                                })}
                            />
                            <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
                                {errors?.size?.message}
                            </p>
                        </div>
                    </div>
                    <div className="flex flex-col gap-4 sm:flex-row sm:gap-8 mt-3">
                        <div className=" w-full">
                            <p className="font-semibold  text-xs mb-2 ml-4 ">Quantity</p>
                            <input
                                type="text"
                                inputMode="numeric"
                                onInput={(e: any) => {
                                    e.target.value = e.target.value.replace(/\D/g, '');
                                }}
                                maxLength={15}
                                className="w-full px-4 py-3 bg-p-gray rounded-full focus:outline-none focus:ring-1 focus:ring-primary-red text-gray-600"
                                placeholder={"Quantity"}
                                {...register("quantity", {
                                    required: "Quantity is required",
                                    min: {
                                        value: 1,
                                        message: "Quantity must be greater than 0 ",
                                    },
                                })}
                            />
                            <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
                                {errors?.quantity?.message}
                            </p>
                        </div>
                        <div className="w-full flex flex-col">
                            <p className="font-semibold  text-xs mb-2 ml-4 ">Status</p>
                            <div className="flex flex-row flex-1 items-center gap-1">
                                <p className="text-xs mb-2 ml-4 w-16">
                                    {productStatus === "active" ? 'Available' : 'Unavailable'}
                                </p>
                                <ToggleInput
                                    onChange={(e: any) => {
                                        setProductStatus(productStatus === "active" ? "unavailable" : "active");
                                    }}
                                    checked={productStatus === "active"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="text-end">
                        <Button
                            onClick={() => !cocktailImg && setImageError('Brand Image is required')}
                            type="submit"
                            disabled={isLoading}
                            className={`text-center px-6 my-5 rounded-full py-2 ${"bg-primary-red hover:bg-primary-red-button-hover text-white"}`}>
                            {isLoading ? editProduct.isEdit ? "Editing..." : 'Adding...' : "Save"}
                        </Button>
                    </div>
                </form>
            </FormModal>
            <FormModal
                overflow="overflow-hidden"
                modalTitle={"Mixers/Syrups"}
                isOpen={isMixersOpen}
                onClose={() => {
                    setMixersIsOpen(false);
                    mixersReset();
                }}
                // Use responsive width classes
                width="w-[95%] sm:w-4/5 md:w-2/3 lg:w-1/2 xl:w-1/3"
            >
                <form onSubmit={mixersHandleSubmit(onMixersSubmit)}>
                    <div className="flex flex-col gap-4 sm:flex-row sm:gap-8 mt-3">
                        <div className="w-full">
                            <p className="font-semibold text-xs mb-2 ml-4">Name</p>
                            <input
                                autoFocus
                                maxLength={50}
                                className="w-full px-4 py-3 bg-p-gray rounded-full focus:outline-none focus:ring-1 focus:ring-primary-red text-gray-600"
                                placeholder="Enter Name"
                                {...mixersRegister("name", {
                                    required: "Name is required",
                                    min: {
                                        value: 1,
                                        message: "Cost must be greater than 0",
                                    },
                                })}
                            />
                            <p className="text-red-500 text-xs mb-2 mt-1 ml-4">
                                {mixersError?.name?.message}
                            </p>
                        </div>
                    </div>

                    <div className="text-end">
                        <Button
                            type="submit"
                            disabled={mixersLoading}
                            className="text-center px-6 my-5 rounded-full py-2 bg-primary-red hover:bg-primary-red-button-hover text-white"
                        >
                            {mixersLoading ? "Adding..." : "Add"}
                        </Button>
                    </div>
                </form>
            </FormModal>
            {/* Change alert modal */}
            <ChangesAlert
                isOpen={changeModal}
                title="Delete item"
                desc="Are you sure you want to delete this item?"
                positiveButtonText="Yes"
                negativeButtonText="&#160;&#160;No&#160;&#160;"
                handleDiscardChanges={handleModalCancel}
                handleSaveChanges={handleModalOkay}
            />
            <ChangesAlert
                isOpen={tabChange.modal}
                title="Unsaved Changed"
                desc="You have unsaved changes. Are you sure you want to leave?"
                positiveButtonText="No, Stay"
                negativeButtonText="Yes, Leave"
                handleDiscardChanges={handleTabModalCancel}
                handleSaveChanges={handleTabModalOkay}
            />
        </div>
    )
}

export default AlcohalAndMixers